import React, { memo, useMemo } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';
import PropTypes from 'prop-types';

import DrawRequestDrawerContent from './DrawRequestDrawerContent';

const DrawRequestDrawer = ({
  isOpen,
  onClose,
  drawRequest,
  applicationId,
  onSuccess,
  availableCredit,
}) => {
  const title = drawRequest ? 'Edit Draw Request' : 'Request Draw';

  const additionalProps = useMemo(
    () => ({ drawRequest, applicationId, onSuccess, availableCredit }),
    [drawRequest, applicationId, onSuccess, availableCredit],
  );

  return (
    <EntityFormModal
      isData
      isHiddenNavigationTabs
      Content={DrawRequestDrawerContent}
      additionalProps={additionalProps}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
    />
  );
};

DrawRequestDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  applicationId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  availableCredit: PropTypes.number,
  drawRequest: PropTypes.object,
};

export default memo(DrawRequestDrawer);
